import PropTypes from 'prop-types';
import { equals } from 'ramda';
import Presenter from 'utils/PropTypesPresenter';

export const compareQuestionValues = (first, second, rule) => {
  const mapper = {
    equal: equals,
  };

  return mapper[rule](first, second);
};

export default new Presenter(
  {
    questionId: PropTypes.number,
    quizFields: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    additionalFieldDescription: PropTypes.string,
    inputLabel: PropTypes.string,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
    totalLabel: PropTypes.string,
  },
  {},
);



// WEBPACK FOOTER //
// ./src/presenters/QuizQuestionPresenter.js